import { CropLandscape } from '@mui/icons-material';
import { defaultSlate } from '../../../../plugins/slate';
import BackgroundDefaultControls from './Controls/Controls';
import { defaultSettings } from './default/settings';
import BackgroundHtmlRenderer from './Renderer/BackgroundHtmlRenderer';
import { ModeEnum } from './types/ModeEnum';

export { ModeEnum };
const background: any = {
  controls: {
    type: 'custom',
    Component: (props: any) => (
      <BackgroundDefaultControls {...props} {...defaultSettings} />
    ),
  },
  Renderer: (props: any) => (
    <BackgroundHtmlRenderer {...props} {...defaultSettings} />
  ),

  id: 'ory/editor/core/layout/background',
  version: 1,

  title: defaultSettings.translations?.pluginName,
  description: defaultSettings.translations?.pluginDescription,
  icon: <CropLandscape />,

  createInitialChildren: () => {
    return [
      [
        {
          plugin: defaultSlate,
          data: defaultSlate.createData(({ plugins }) => ({
            children: [
              {
                plugin: plugins.custom.custom1,
                children: [''],
              },
            ],
          })),
        },
      ],
    ];
  },
  cellStyle: defaultSettings.cellStyle,
};

export default background;
